// extracted by mini-css-extract-plugin
export default {"root":"app-react-components-ViewLoading-ViewLoading-module__root","message":"app-react-components-ViewLoading-ViewLoading-module__message"};